import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import { CardInformative } from "@/pages/esus/ReterritorializationAcsDashboard/CardInformative";

type Props = {
	totalObservations: number;
	totalBriefObservations: number;
	totalHospitalizations: number;
	totalDeaths: number;
	deathsLessThan24h: number;
	deathsMoreThan24h: number;
};

export function HospitalizationDashboardCards({
	totalObservations,
	totalBriefObservations,
	totalHospitalizations,
	totalDeaths,
	deathsLessThan24h,
	deathsMoreThan24h,
}: Readonly<Props>) {
	return (
		<>
			<Row className="py-2 bg-white justify-content-evenly rounded">
				<Col sm={12} md={4} lg={3} xxl={3} className="my-2">
					<CardInformative
						title="Admitidos no período"
						value={totalObservations.toLocaleString()}
						classNameCard="m-2 rounded p-2 bg-primary h-100"
						classNameTitle="text-white text-center"
						classNameValue="text-white"
					/>
				</Col>
				<Col sm={12} md={4} lg={3} xxl={3} className="my-2">
					<CardInformative
						title="Ocupação no período"
						classNameCard="border border-muted rounded p-2 m-2 bg-white h-100"
						value={totalBriefObservations.toLocaleString()}
						classNameTitle="text-muted text-center"
						classNameValue="text-muted"
					/>
				</Col>
				<Col sm={12} md={4} lg={3} xxl={3} className="my-2">
					<CardInformative
						title="Total de transferências"
						classNameCard="border border-muted rounded p-2 m-2 bg-white h-100"
						classNameTitle="text-muted text-center"
						classNameValue="text-muted"
						value={totalHospitalizations.toLocaleString()}
					/>
				</Col>
			</Row>

			<Row className="py-2 bg-white justify-content-evenly rounded">
				<Col sm={12} md={4} lg={3} xxl={3} className="my-2">
					<CardInformative
						title="Total de óbitos"
						classNameCard="border border-muted rounded p-2 m-2 bg-white h-100"
						classNameTitle="text-muted text-center"
						classNameValue="text-muted"
						value={totalDeaths.toLocaleString()}
					/>
				</Col>
				<Col sm={12} md={4} lg={3} xxl={3} className="my-2">
					<CardInformative
						title="Óbitos <=24h"
						classNameCard="border border-muted rounded p-2 m-2 bg-white h-100"
						classNameTitle="text-muted text-center"
						classNameValue="text-muted"
						value={deathsLessThan24h.toLocaleString()}
					/>
				</Col>
				<Col sm={12} md={4} lg={3} xxl={3} className="my-2">
					<CardInformative
						title="Óbitos > 24h"
						classNameCard="border border-muted rounded p-2 m-2 bg-white h-100"
						classNameTitle="text-muted text-center"
						classNameValue="text-muted"
						value={deathsMoreThan24h.toLocaleString()}
					/>
				</Col>
			</Row>
		</>
	);
}
